import {
  LIST_LIBRARY_REQUEST,
  LIST_LIBRARY_SUCCESS,
  LIST_LIBRARY_FAIL,
  LIST_LIBRARY_SUMMARY_REQUEST,
  LIST_LIBRARY_SUMMARY_SUCCESS,
  LIST_LIBRARY_SUMMARY_FAIL,
  DETAIL_LIBRARY_REQUEST,
  DETAIL_LIBRARY_SUCCESS,
  DETAIL_LIBRARY_FAIL,
  UPDATE_LIBRARY_REQUEST,
  UPDATE_LIBRARY_SUCCESS,
  UPDATE_LIBRARY_FAIL,
  LIST_SUMMARY_GENERATOR_LIBRARY_REQUEST,
  LIST_SUMMARY_GENERATOR_LIBRARY_SUCCESS,
  LIST_SUMMARY_GENERATOR_LIBRARY_FAIL,
  CREATE_SUMMARY_GENERATOR_LIBRARY_REQUEST,
  CREATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS,
  CREATE_SUMMARY_GENERATOR_LIBRARY_FAIL,
  DETAIL_SUMMARY_GENERATOR_LIBRARY_REQUEST,
  DETAIL_SUMMARY_GENERATOR_LIBRARY_SUCCESS,
  DETAIL_SUMMARY_GENERATOR_LIBRARY_FAIL,
  UPDATE_SUMMARY_GENERATOR_LIBRARY_REQUEST,
  UPDATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS,
  UPDATE_SUMMARY_GENERATOR_LIBRARY_FAIL,
  DELETE_SUMMARY_GENERATOR_LIBRARY_REQUEST,
  DELETE_SUMMARY_GENERATOR_LIBRARY_SUCCESS,
  DELETE_SUMMARY_GENERATOR_LIBRARY_FAIL,
  DUPLICATE_SUMMARY_GENERATOR_LIBRARY_REQUEST,
  DUPLICATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS,
  DUPLICATE_SUMMARY_GENERATOR_LIBRARY_FAIL
} from '../../constants/summary-generator-library'

const initialState = {
  loading: false,
  loadingDelete: false,
  loadingCreate: false,
  summaryGenerators: [],
  summaryGenerator: {},
  summaryLibrary: {},
  summaryLibrarySummary: {},
  pageable: {
    page: 1,
    size: 10
  },
  error: ''
}

const summaryGeneratorLibraryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_LIBRARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_LIBRARY_SUCCESS:
      return {
        ...state,
        loading: false,
        summaryGenerators: action.payload,
        pageable: action.pageable
      }
    case LIST_LIBRARY_FAIL:
      return {
        ...state,
        loading: false,
        summaryGenerators: {},
        error: action.payload
      }
    case LIST_LIBRARY_SUMMARY_REQUEST:
      return {
        ...state,
        summaryLibrarySummary: [],
        loading: true
      }
    case LIST_LIBRARY_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        summaryLibrarySummary: action.payload,
        pageable: action.pageable
      }
    case LIST_LIBRARY_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DETAIL_LIBRARY_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case DETAIL_LIBRARY_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        summaryLibrary: action.payload
      }
    case DETAIL_LIBRARY_FAIL:
      return {
        ...state,
        loadingCreate: false,
        summaryLibrary: {},
        error: action.payload
      }
    case UPDATE_LIBRARY_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case UPDATE_LIBRARY_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case UPDATE_LIBRARY_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case LIST_SUMMARY_GENERATOR_LIBRARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SUMMARY_GENERATOR_LIBRARY_SUCCESS:
      return {
        ...state,
        loading: false,
        summaryGenerators: action.payload
      }
    case LIST_SUMMARY_GENERATOR_LIBRARY_FAIL:
      return {
        ...state,
        loading: false,
        summaryGenerators: [],
        error: action.payload
      }
    case CREATE_SUMMARY_GENERATOR_LIBRARY_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_SUMMARY_GENERATOR_LIBRARY_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_SUMMARY_GENERATOR_LIBRARY_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        summaryGenerator: {}
      }
    case DETAIL_SUMMARY_GENERATOR_LIBRARY_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        summaryGenerator: action.payload
      }
    case DETAIL_SUMMARY_GENERATOR_LIBRARY_FAIL:
      return {
        ...state,
        loadingDetail: false,
        summaryGenerator: {},
        error: action.payload
      }
    case UPDATE_SUMMARY_GENERATOR_LIBRARY_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case UPDATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case UPDATE_SUMMARY_GENERATOR_LIBRARY_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DUPLICATE_SUMMARY_GENERATOR_LIBRARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DUPLICATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case DUPLICATE_SUMMARY_GENERATOR_LIBRARY_FAIL:
      return {
        ...state,
        loading: false,
        summaryGenerator: {},
        error: action.payload
      }
    case DUPLICATE_SUMMARY_GENERATOR_LIBRARY_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case DUPLICATE_SUMMARY_GENERATOR_LIBRARY_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case DUPLICATE_SUMMARY_GENERATOR_LIBRARY_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DELETE_SUMMARY_GENERATOR_LIBRARY_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_SUMMARY_GENERATOR_LIBRARY_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        services: state.services
      }
    case DELETE_SUMMARY_GENERATOR_LIBRARY_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default summaryGeneratorLibraryReducer

